module.exports = __webpack_public_path__ + "static/media/alert-icon.5998e4f9.svg";